import React, { useState } from "react";
import { Grid, Tab, Tabs } from "@material-ui/core";
import CarnetTableTab from "./CarnetTableTab";
import DocumentsTableTab from "./DocumentsTableTab";
import BalanceTab from "./BalanceTab";

const style = { marginBottom: "10px", width: "100%" };
const styleGrid = { paddingLeft: "2%" };

const AdditionalInfo: React.FC = () => {
  const [tab, setTab] = useState(0);

  return (
    <Grid container justify={"center"}>
      <Grid item xs={12}>
        <Tabs style={style} centered indicatorColor="primary" value={tab} onChange={(e, value) => setTab(value)}>
          <Tab label="Stan konta" />
          <Tab label="Zakupy" />
          <Tab label="Dokumenty" />
        </Tabs>
      </Grid>
      {tab === 0 && (
        <Grid item xs={12}>
          <BalanceTab />
        </Grid>
      )}
      {tab === 1 && (
        <Grid item xs={12} style={styleGrid}>
          <CarnetTableTab />
        </Grid>
      )}
      {tab === 2 && (
        <Grid item xs={12}>
          <DocumentsTableTab />
        </Grid>
      )}
    </Grid>
  );
};

export default AdditionalInfo;
